<div class="ap-skeleton">
    <ng-content></ng-content>
</div>
